import { DiscountTypography, PriceTypography, Typography } from '@musinsa/mds';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.DiscountPriceRow';

interface Props {
  finalPrice: number;
  finalDiscount: number;
  hasOptionPrice?: boolean | null;
  className?: string;
}

export const DiscountPriceRow: FC<Props> = ({
  finalPrice,
  finalDiscount,
  hasOptionPrice,
  className,
}) => (
  <div className={twMerge('flex flex-col pt-1', className)}>
    <div className="inline-flex">
      {finalDiscount !== 0 && (
        <Typography variant="body13pxSemi" colorScheme="red">
          <DiscountTypography discount={finalDiscount} />
        </Typography>
      )}
      <Typography variant="body13pxSemi" className={finalDiscount !== 0 ? 'pl-0.5' : undefined}>
        {finalPrice > 0 ? <PriceTypography price={finalPrice} /> : '0원'}
      </Typography>
    </div>
    {hasOptionPrice && (
      <Typography variant="textEtc11pxReg" colorScheme="gray-500" className="pt-0.5">
        옵션비 별도
      </Typography>
    )}
  </div>
);

DiscountPriceRow.displayName = DISPLAY_NAME;
